import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppColor from "utilities/AppColor";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { SHIFT_COLOR } from "config/AppConfig";
import { Field, FieldArray } from "formik";
import SelectField from "components/Select/SelectField";
import { SHIFT } from "config/AppConfig";
import SelectTime from "components/Select/SelectTime";
// import AppButton from "components/CustomButtons/AppButton";
import AppUtil from "utilities/AppUtil";
import { Label } from "reactstrap";
import AppDialog from "components/Dialog/AppDialog";
// import { Label } from "reactstrap";

const useStyles = makeStyles(() => ({
  label: {
    fontSize: 14,
    color: AppColor.black,
    fontWeight: "500",
  },
  wrapShift: {
    // border: "1px solid #c4b5bc",
    // boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
    padding: " 0 1rem 0.5rem 1rem",
    borderRadius: 4,
    marginBottom: "0.5rem",
    "& .shiftInfo": {
      // margin: "-1rem -1rem 1rem -1rem",
      padding: "0.3rem 1rem",
      border: "1px solid #c4b5bc",
      borderRadius: 4,
      backgroundColor: AppColor.white,
      display: "flex",
      justifyContent: "space-between",
      width: '100%',
      cursor: "pointer",
    },
    "& .shiftInfo.MORNING": {
      backgroundColor: SHIFT_COLOR.MORNING,
      color: '#fff'
    },
    "& .shiftInfo.AFTERNOON": {
      backgroundColor: SHIFT_COLOR.AFTERNOON,
      color: '#fff'
    },
    "& .shiftInfo.EVENING": {
      backgroundColor: SHIFT_COLOR.EVENING,
      color: '#fff'
    },
    "& .shiftInfo.NIGHT": {
      backgroundColor: SHIFT_COLOR.NIGHT,
      color: '#fff'
    },
    "& .shiftInfo.default": {
      backgroundColor: '#f2f2f2',
      color: '#000',
    },
    "& .remove-icon": {
      fontSize: "2rem",
      color: AppColor.red,
    },
  },
  collapseShift: {
    // border: "1px solid #c4b5bc",
    // boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0 1rem",
    margin: "0.5rem 0",
    "& .shiftInfo": {
      margin: 0,
      padding: "0.3rem 1rem",
      border: "1px solid #c4b5bc",
      borderRadius: 4,
      backgroundColor: AppColor.white,
      display: "flex",
      justifyContent: "space-between",
      width: '100%',
      cursor: "pointer",
    },
    "& .shiftInfo.MORNING": {
      backgroundColor: SHIFT_COLOR.MORNING,
      color: '#fff'
    },
    "& .shiftInfo.AFTERNOON": {
      backgroundColor: SHIFT_COLOR.AFTERNOON,
      color: '#fff'
    },
    "& .shiftInfo.EVENING": {
      backgroundColor: SHIFT_COLOR.EVENING,
      color: '#fff'
    },
    "& .shiftInfo.NIGHT": {
      backgroundColor: SHIFT_COLOR.NIGHT,
      color: '#fff'
    },
    "& .shiftInfo.default": {
      backgroundColor: '#f2f2f2',
      color: '#000',
    },
    "& .remove-icon": {
      fontSize: "2rem",
      color: AppColor.red,
      paddingRight: '3px',
    },
  },
  deleteRight: {
    cursor: "pointer",
  },
  disabled: {
    opacity: 0.6,
    pointerEvents: "none",
  },
  jobAvailabilityRequest: {
    width: '100%',
    margin: '1rem 0',
    borderRadius: '5px',
    border: "1px dashed #c4b5bc",
    boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
  },
  jobAvailabilityRequestExpand: {
    width: '100%',
    margin: '1rem 0',
    padding: '1rem 0',
    borderRadius: '5px',
    border: "1px solid #c4b5bc",
    boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
  },
  headerAvailabilityDayOfWeek: {
    display: 'flex',
    width: `${100/7}%`,
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 2px 4px 2px',
    backgroundColor: '#f1eeec',
  },
  bodyAvailabilityDayOfWeek: {
    display: 'flex',
    width: `${100/7}%`,
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #e0e0e0',
    margin: '0 2px',
    backgroundColor: '#f8f8f8',
  },
  rootCheckBox: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  iconCheckBox: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIconCheckBox: {
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
  borderTopLeft: {
    borderTopLeftRadius: "10px",
  },
  borderTopRight: {
    borderTopRightRadius: "10px",
  },
  borderBottomLeft: {
    borderBottomLeftRadius: "10px",
  },
  borderBottomRight: {
    borderBottomRightRadius: "10px",
  },
  wrapSaveButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0.5rem',
  },
  // segment
  segmentContainer: {
    position: 'relative',
    padding: '1rem',
    borderRadius: '5px',
    border: '1px dashed #c4b5bc',
    marginTop: '2rem',
    
  },
  buttonAdd: {
    top: '-15px',
    left: 20,
    height: '30px',
    display: 'flex',
    padding: '0 0.5rem',
    position: 'absolute',
    alignItems: 'center',
    backgroundColor: '#fff',
    justifyContent: 'space-around',
  },
  buttonViewNextWeek: {
    top: '-15px',
    right: 20,
    height: '30px',
    display: 'flex',
    padding: '0 0.5rem',
    position: 'absolute',
    alignItems: 'center',
    backgroundColor: '#fff',
    justifyContent: 'space-around',
  },
  textButtonAdd: {
    cursor: 'pointer',
    fontWeight: 'bold',
    color: AppColor.mainBlue,
  },
  textViewNextWeek: {
    cursor: 'pointer',
    fontWeight: 'bold',
    color: AppColor.mainBlue,
  },
  segmentError: {
    borderColor: AppColor.red,
    borderWidth: '3px',
  }
}));

const SegmentFieldArray = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    startDate,
    handleChange,
    setFieldValue,
    fieldArrayName,
    settingNextWeek,
    jobAvailability,
    minTime,
    maxTime,
    isUsingCurrentDate,
    isDisabled
  } = props

  const defaultSegment = {
    shiftType: "",
    startTime: moment(isUsingCurrentDate !== false ? new Date() : minTime).hours(0).minutes(0).format("YYYY/MM/DD HH:mm:ss"),
    endTime: moment(isUsingCurrentDate !== false ? new Date() : maxTime).hours(0).minutes(0).format("YYYY/MM/DD HH:mm:ss"),
    isExpand: true,
    status: 'ACTIVE',
  };

  const { segments = [], shiftType } = jobAvailability;
  const [showDataNextWeek, setShowDataNextWeek] = useState(false);

  const shiftOptions = SHIFT.filter(item => item !== shiftType);

  const handleAddSegment = (insert) => {
    // if (segmentsActive && segmentsActive.length < 3) {
      insert(segments.length, {
        ...defaultSegment
      });
    // }
  }

  const _handleSelectChangeStartEndTime = (index, event, name) => {
    const date = startDate ? moment(startDate) : moment();
    const newValues = [...segments];
    if (index > -1) {
      event = moment(new Date(event)).set({
          year: date.get('year'),
          month: date.get('month'),
          date: date.get('date')
      });
      const momentMinTime = moment(minTime);
      const momentMaxTime = moment(maxTime);
      
      switch (name) {
        case 'startTime':
          if (moment(event).hours() === momentMinTime.hours() && moment(event).minutes() < momentMinTime.minutes()) {
            event.minutes(momentMinTime.minutes());
          }
          break;
        case 'endTime':
          if (moment.range(momentMinTime, event).diff('minutes') === 0 && moment.range(momentMinTime, momentMaxTime).diff('hours') === 24) {
            event.add(1, 'days');
            break;
          }
          if (moment(event).hours() === momentMaxTime.hours() && moment(event).minutes() > momentMaxTime.minutes()) {
            event.minutes(momentMaxTime.minutes());
          }
          break;
        default:
          break;
      }
      // event is next day
      if (moment.range(momentMinTime, event).diff('minutes') < 0) {
        event.add(1, 'days');
      }
      newValues[index][name] = event.format('YYYY/MM/DD HH:mm:ss');
      handleChange({
        target: {
          name: fieldArrayName,
          value: newValues
        }
      });
      return null;
    }
  }
  // const segmentsActive = segments.filter(segment => segment.status !== 'INACTIVE');

  if (!segments) {
    return null;
  }
  
  return (
    <FieldArray
      name={fieldArrayName}
      render={({ insert, remove }) => (
        <React.Fragment>
          <Box className={classes.segmentContainer}>
            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%' }}>
              {/* Button add */}
              <div className={`${classes.buttonAdd}`} disabled={isDisabled} onClick={() => {
                if(!isDisabled)
                  {
                    handleAddSegment(insert)
                  }
              }} >
                <div className={`${classes.textButtonAdd}`}>
                  <i className="fas fa-plus"></i>
                  <span style={{ marginLeft: '3px' }}>{t("button.addConfiguration")}</span>
                </div>
              </div>
              {/* Button view next week */}
              {
                settingNextWeek && settingNextWeek.segments && settingNextWeek.segments.length > 0 &&
                <div className={`${classes.buttonViewNextWeek}`} onClick={() => setShowDataNextWeek(true)} >
                  <div className={`${classes.textViewNextWeek}`}>
                    <span>{t("button.viewNextWeek")}</span>
                  </div>
                </div>
              }
            </div>
            {
              segments && segments.map((item, index) => {
                const { shiftType: shiftTypeSegments, startTime, endTime, isExpand, status } = item;
                var isConflict = false; 
                // var isDuplicatesShiftType = false;
                let isInvalidShiftType = shiftTypeSegments === shiftType;
                var isInvalidStartTime = startTime === '' || moment.range(minTime, moment(startTime)).diff('minutes') < 0 || moment.range(moment(startTime), maxTime).diff('minutes') < 0;
                var isInvalidEndTime = endTime === '' || moment.range(minTime, moment(endTime)).diff('minutes') < 0 || moment.range(moment(endTime), maxTime).diff('minutes') < 0;

                var classNameSegmentContainer = isExpand ? classes.jobAvailabilityRequestExpand : classes.jobAvailabilityRequest;
                if (status === 'INACTIVE') {
                  return null;
                }
                for (let i = 0; i < segments.length; i++) {
                  if (segments[i].status === 'ACTIVE' && i !== index) {
                    // check conflict time
                    if (!isConflict && startTime && endTime && segments[i].startTime && segments[i].endTime && segments[i].shiftType !== '' && shiftTypeSegments !== '') {
                      isConflict = AppUtil.isConflictTime({ startTime: moment(startTime), endTime: moment(endTime) }, { startTime: moment(segments[i].startTime), endTime: moment(segments[i].endTime) });
                    }
                    // check duplicates shift type
                    // if (!isDuplicatesShiftType && shiftTypeSegments && segments[i].shiftType ) {
                    //   isDuplicatesShiftType = shiftTypeSegments === segments[i].shiftType;
                    // }
                  }
                }
                // check required
                if (isInvalidShiftType || isConflict || isInvalidStartTime || isInvalidEndTime || !shiftTypeSegments || !startTime || !endTime || shiftTypeSegments === '' || startTime === '' || endTime === '') {
                  classNameSegmentContainer = `${classNameSegmentContainer} ${classes.segmentError}`;
                }
                return (
                  <Box key={`ip-segment-${index}`} className={classNameSegmentContainer}>
                    <Box className={ isExpand ? classes.wrapShift : classes.collapseShift }>
                      {
                        !isExpand &&
                        <Box className={"remove-icon"}>
                          <Box
                            className={classes.deleteRight}
                            onClick={() => {
                              remove(index);
                              // if (id || id === 0) {
                              //   setFieldValue(`${fieldArrayName}[${index}].status`, 'INACTIVE');
                              // } else {
                              //   remove(index);
                              // }
                            }}
                          >
                            <i className="far fa-times-circle"></i>
                          </Box>
                        </Box>
                      }
                      <Box className={`shiftInfo ${shiftTypeSegments ? shiftTypeSegments : 'default'}`} onClick={() => setFieldValue(`${fieldArrayName}[${index}].isExpand`, !isExpand)}>
                        <span>
                          {`${shiftTypeSegments ? t(`shift.${shiftTypeSegments}`) : ""} ${startTime ? moment(startTime).format("HH:mm") : "00:00" }
                              - 
                              ${endTime ? moment(endTime).format("HH:mm") : "00:00"}`}
                        </span>
                      </Box>
                      {
                        isExpand &&
                        <React.Fragment>
                          {/* Shift Type */}
                          <Field
                            component={SelectField}
                            name={`${fieldArrayName}[${index}].shiftType`}
                            label={"label.shift"}
                            notCheckTouch={true}
                            options={shiftOptions.map((item) => {
                              return {
                                value: item,
                                label: t(`shift.${item}`),
                              };
                            })}
                            onSelected={() => {
                              // const date = startDate ? moment(startDate) : moment();
                              setFieldValue(`${fieldArrayName}[${index}].startTime`, '');
                              setFieldValue(`${fieldArrayName}[${index}].endTime`, '');
                            }}
                            required
                          />
                          {minTime && maxTime && (
                            <Box>
                              <Label className={`${classes.label}`} style={{ color: AppColor.pink }}>
                                <span>Valid time: </span>
                                <span>{`${moment(minTime).format("HH:mm")} today - ${moment(maxTime).format("HH:mm")} ${minTime.date() !== maxTime.date() ? 'next day' : 'today' }`}</span>
                              </Label>
                            </Box>
                          )}
                          {
                            isConflict &&
                            <Label className={`${classes.label}`} style={{ color: AppColor.red }}>
                              {t("validation.conflictTime")}
                            </Label>
                          }
                          {/* Start Time End Time */}
                          <Field
                            component={SelectTime}
                            onSelected={(event) => _handleSelectChangeStartEndTime(index, event, 'startTime')}
                            name={`${fieldArrayName}[${index}].startTime`}
                            disabled={ !shiftTypeSegments || shiftTypeSegments === ""}
                            minTime={moment().hours(minTime.hours()).minutes(0).format('HH:mm')}
                            maxTime={moment().hours(maxTime.hours()).minutes(59).format('HH:mm')}
                            isSelect24H={(minTime.hours() === maxTime.hours() && minTime.minutes() >= maxTime.minutes())}
                            shouldDisableTime={({timeValue, clockType}) => {
                              switch (clockType) {
                                case 'minutes':{
                                  // min to max is 24h
                                  if (minTime.hours() === maxTime.hours() && minTime.minutes() === maxTime.minutes()) {
                                    return true;
                                  }
                                  if (moment(startTime).hours() === minTime.hours()) {
                                    return timeValue >= minTime.minutes();
                                  }
                                  if (moment(startTime).hours() === maxTime.hours()) {
                                    return timeValue <= maxTime.minutes();
                                  }
                                  return true;
                                }
                                default:
                                    return true;
                              }
                            }}
                            label={"label.startTime"}
                            isFlexible={true}
                            required
                          />
                          {
                            isInvalidStartTime &&
                            <Label className={`${classes.label}`} style={{ color: AppColor.red }}>
                              {t("validation.startTimeInvalid")}
                            </Label>
                          }
                          <Field
                            component={SelectTime}
                            onSelected={(event) => _handleSelectChangeStartEndTime(index, event, 'endTime')}
                            name={`${fieldArrayName}[${index}].endTime`}
                            disabled={ !shiftTypeSegments || shiftTypeSegments === "" }
                            minTime={moment().hours(minTime.hours()).minutes(0).format('HH:mm')}
                            maxTime={moment().hours(maxTime.hours()).minutes(59).format('HH:mm')}
                            isSelect24H={(minTime.hours() === maxTime.hours() && minTime.minutes() >= maxTime.minutes())}
                            shouldDisableTime={({timeValue, clockType}) => {
                              switch (clockType) {
                                case 'minutes':{
                                  if (moment(endTime).hours() === minTime.hours()) {
                                    return timeValue >= minTime.minutes();
                                  }
                                  if (moment(endTime).hours() === maxTime.hours()) {
                                    return timeValue <= maxTime.minutes();
                                  }
                                  return true;
                                }
                                default:
                                    return true;
                              }
                            }}
                            label={"label.endTime"}
                            isFlexible={true}
                            required
                          />
                          {
                            isInvalidEndTime &&
                            <Label className={`${classes.label}`} style={{ color: AppColor.red }}>
                              {t("validation.endTimeInvalid")}
                            </Label>
                          }
                        </React.Fragment>
                      }
                    </Box>
                  </Box>
                );
              })
            }
          </Box>
          {
            settingNextWeek &&
            <AppDialog
              open={showDataNextWeek}
              // actions={[{
              //   label: t('button.cancel'),
              //   onPress: () => {setShowDataNextWeek(false)},
              //   mode: "outlined",
              // }]}
              title={t('title.configurationOfNextWeek')}
              onClose={() => setShowDataNextWeek(false)}
            >
              <div>
                {
                  settingNextWeek.segments && settingNextWeek.segments.map((item, index) => {
                    const { shiftType: shiftTypeSegments, startTime, endTime, isExpand } = item
                    return (
                      <Box key={`ip-segment-setting-next-week-${index}`} className={isExpand ? classes.jobAvailabilityRequestExpand : classes.jobAvailabilityRequest}>
                        <Box className={ isExpand ? classes.wrapShift : classes.collapseShift }>
                          <Box className={`shiftInfo ${shiftTypeSegments ? shiftTypeSegments : 'default'}`}>
                            <span>
                              {`${shiftTypeSegments ? t(`shift.${shiftTypeSegments}`) : ""} ${startTime ? moment(startTime).format("HH:mm") : "00:00" }
                                  - 
                                  ${endTime ? moment(endTime).format("HH:mm") : "00:00"}`}
                            </span>
                          </Box>
                          {
                            // isExpand &&
                            // <React.Fragment>
                            //   {/* Shift Type */}
                            //   <Field
                            //     component={SelectField}
                            //     name={`${settingNextWeekName}.segments[${index}].shiftType`}
                            //     label={"label.shift"}
                            //     notCheckTouch={true}
                            //     options={SHIFT.map((item) => {
                            //       return {
                            //         value: item,
                            //         label: t(`shift.${item}`),
                            //       };
                            //     })}
                            //     disabled={true}
                            //   />
                            //   {/* Start Time End Time */}
                            //   <Field
                            //     component={SelectTime}
                            //     name={`${settingNextWeekName}.segments[${index}].startTime`}
                            //     disabled={true}
                            //     label={"label.startTime"}
                            //   />
                            //   <Field
                            //     component={SelectTime}
                            //     name={`${settingNextWeekName}.segments[${index}].endTime`}
                            //     disabled={true}
                            //     label={"label.endTime"}
                            //   />
                            // </React.Fragment>
                          }
                        </Box>
                      </Box>
                    );
                  })
                }
              </div>
            </AppDialog>
          }
        </React.Fragment>
      )}
    />
  );
};

SegmentFieldArray.propTypes = {
  setFieldValue: PropTypes.func,
  handleChange: PropTypes.func,
  fieldArrayName: PropTypes.string,
  jobAvailability: PropTypes.object,
  minTime: PropTypes.any,
  maxTime: PropTypes.any,
  startDate: PropTypes.any,
  // settingNextWeekName: PropTypes.string,
  settingNextWeek: PropTypes.object,
  isUsingCurrentDate: PropTypes.bool,
  isDisabled: PropTypes.bool
};
export default SegmentFieldArray;
